﻿/*************** CAROUSEL CLICK TRACKING START ***********************/

window.Shoply = window.Shoply || {};
window.Shoply.Tracking = (function () {
    const endpoint = "/track/carousel-click";

    function trackClick(productId, placement, countryCode, contextProductId) {
        fetch(endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                productId: parseInt(productId),
                placement: parseInt(placement),
                countryCode: countryCode,
                contextProductId: contextProductId ? parseInt(contextProductId) : null
            })
        });
    }

    function attachClickTracking() {
        document.querySelectorAll(".carousel-link").forEach(el => {
            el.addEventListener("click", function () {
                const productId = el.dataset.productId;
                const placement = el.dataset.placement;
                const country = el.dataset.country;
                const contextProductId = el.dataset.contextProductId;

                if (productId && placement && country) {
                    trackClick(productId, placement, country, contextProductId);
                }
            });
        });
    }

    function init() {
        attachClickTracking();
    }

    return { init };
})();

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector(".carousel-link")) {
        Shoply.Tracking.init();
    }
});

/*************** CAROUSEL CLICK TRACKING END ***********************/
